module.exports = __webpack_public_path__ + "img/file-upload.83d26aeb.svg";